import { LayoutInitService } from 'src/app/RefModules/_metronic/core';
import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';

@Component({
    selector: 'app-instance-content',
    templateUrl: './instance-content.component.html',
    styleUrls: ['./instance-content.component.scss'],
})
export class InstanceContentComponent implements OnInit {
    constructor(
        private layoutInitService: LayoutInitService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.layoutInitService.init();
    }

    navigateToInstance() {
        if (localStorage.getItem('selectedOrgId')) {
            this.router.navigate(['/management/instance'], { queryParams: { organizationId: `${localStorage.getItem('selectedOrgId')}` } });
        }
    }
}
